import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { getVoting, submitPoll } from '../../redux/data/dataActions';
import { setPhoneNumber, setTermsAndConditions, setPollSubmissionSuccess, setPollSubmissionError } from '../../redux/data/dataSlice';
import "../../assets/css/voting.css";
import CloseImage from "../../assets/images/close.svg";
import DeniedIcon from "../../assets/images/denied.svg";
import SuccessIcon from "../../assets/images/success.svg";
import PollResults from "./pollResults";
import config from "../../config/memberhubContents.json";
import PollAnswerOptions from "./pollAnswerOptions";

function PollModal(props) {
    const dispatch = useDispatch();
    const pollSubmissionSuccess = useSelector(state => state.data.pollSubmissionSuccess);
    const pollSubmissionError = useSelector(state => state.data.pollSubmissionError);
    const [userSelection, setUserSelection] = useState(null);
    const [completedDateText, setCompletedDateText] = useState("");
    const [completedDate,] = useState(props && props.selectedPoll && props.selectedPoll.response && props.selectedPoll.response.create_date);

    const pollCompleted = props && props.selectedPoll.response && props.selectedPoll.results;
    const showResults = props && props.selectedPoll.chart && props.selectedPoll.chart.type;
    const rectangularImgs = props && props.selectedPoll.extra_data && props.selectedPoll.extra_data.image_size
        && props.selectedPoll.extra_data.image_size === "1";
    const answerOptions = props.selectedPoll.question && props.selectedPoll.question.answer_options ?
        props.selectedPoll.question.answer_options : null;

    useEffect(() => {
        if (completedDate) {
            const completedDateObj = new Date(completedDate * 1000);
            const selectionId = props.selectedPoll.response.data && props.selectedPoll.response.data.poll_response;
            const selection = selectionId ? props.selectedPoll.question.answer_options.find(a => a.id === +selectionId) : null;
            const selectionValue = selection && selection.value ? <div className="selection">Selection: {selection.value}</div> : "";
            const text = <div className="modal-completed">
                <div className="completed-date">
                    You voted in {completedDateObj.toLocaleString('default', { month: 'long' })} {completedDateObj.getFullYear()}
                </div>
                {selectionValue}
            </div>;
            setCompletedDateText(text);
        }
    }, [props, completedDate]);

    const handleSelection = activityId => {
        setUserSelection(activityId);
        dispatch(setPollSubmissionError(""));
    };

    const submitUserSelection = () => {
        if (!userSelection || !props.selectedPoll.id) {
            dispatch(setPollSubmissionSuccess(false));
            dispatch(setPollSubmissionError(config.pollSubmissionErrorNoSelection));
            return;
        }
        dispatch(setPollSubmissionError(""));
        const payload = { activity_id: props.selectedPoll.id, poll_response: userSelection };
        dispatch(submitPoll(payload));
    };

    return (
        <>
            <div className="modal-header">
                <Link
                    to={{ pathname: "/voting", search: window.location.search }}
                    className="modal-close"
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="voting"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getVoting());
                        dispatch(setPhoneNumber(""));
                        dispatch(setTermsAndConditions(false));
                        dispatch(setPollSubmissionSuccess(false));
                        dispatch(setPollSubmissionError(""));
                    }}>
                    <img alt="close" src={CloseImage} />
                </Link>
            </div>
            <div className="modal-header-title">
                {props.selectedPoll.title}
            </div>
            <div className="modal-header-subtitle">
                {props.selectedPoll.description}
            </div>
            <div className="modal-question">
                {props.selectedPoll.question.value}
            </div>
            {pollSubmissionSuccess || pollCompleted ?
                <div className={`modal-success ${pollCompleted ? 'completed' : ''}`} style={{ marginBottom: 0 }}>
                    <img src={SuccessIcon} alt="Success" style={{ width: '20px', height: '20px' }} />
                    {pollCompleted ? completedDateText : showResults ? config.pollSubmissionSuccess : config.pollSubmissionSuccessNoResults}
                </div>
                : pollSubmissionError &&
                <div className="modal-error">
                    <img src={DeniedIcon} alt="Error" style={{ width: '20px', height: '20px' }} />
                    {pollSubmissionError}
                </div>
            }
            <div className="modal-header-separator"></div>
            <div className={`modal-body modal-poll-body ${pollSubmissionSuccess || pollCompleted ? showResults ? 'result-graph' : 'no-results' : ''}`}>
                {pollSubmissionSuccess || pollCompleted ?
                    showResults && <PollResults results={pollCompleted} />
                    :
                    <PollAnswerOptions answerOptions={answerOptions} rectangularImgs={rectangularImgs} handleSelection={handleSelection} />
                }
            </div>
            <div className="modal-footer poll-footer">
                <div className="modal-header-separator noshow-on-mobile" style={{ width: '100%' }}></div>
                {pollSubmissionSuccess || pollCompleted ?
                    <Link
                        onClick={() => {
                            props.setShowModal(false);
                            dispatch(getVoting());
                            dispatch(setPhoneNumber(""));
                            dispatch(setTermsAndConditions(false));
                            dispatch(setPollSubmissionSuccess(false));
                            dispatch(setPollSubmissionError(""));
                        }}
                        className="modal-button-cta"
                        to={{ pathname: "/voting", search: window.location.search }}
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-content={props.selectedPoll.title}
                        data-section="voting"
                        data-type="dismiss">
                        {config.returnToBenefits}
                    </Link>
                    :
                    <div
                        onClick={submitUserSelection}
                        className={`modal-button-cta ${!userSelection ? 'disabled' : ''}`}
                        data-track="click"
                        data-id="nba:membership-hub:outbound:cta"
                        data-content={props.selectedPoll.title}
                        data-type="cta">
                        {config.submit}
                    </div>
                }
            </div>
        </>
    );
}

export default PollModal;
